import { FormDataBuilder } from '../types';
import { onboardGithubRepoFormBuilder } from './github';
import { tenantFormBuilder } from './kaap';
import { onboardTechDocsFormDataBuilder } from './techdocs';

// the key needs to be the same as the template name
const templateBuilderMappers: Record<string, FormDataBuilder> = {
  // github and repository
  'onboard-github-repo': onboardGithubRepoFormBuilder,

  // kaap
  'dx-cra-kaap-update-tenant': tenantFormBuilder,

  // techdocs
  'repository-techdocs-onboard': onboardTechDocsFormDataBuilder,
};

export const formDataBuilderFactory = (
  templateName: string | undefined,
): FormDataBuilder | undefined => {
  if (!templateName) return undefined;

  if (Object.keys(templateBuilderMappers).indexOf(templateName) !== -1) {
    return templateBuilderMappers[templateName];
  }

  return undefined;
};
